import { __, Alert, confirm } from 'modules/theme';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import APIManager from 'modules/common/apiManager';
import {
  ModalTrigger,
  Pagination,
  Button,
  ButtonCommonTheme,
  FormControl,
  Table,
  Label,
  DataWithLoader,
  FormGroup,
  Tip,
  ControlLabel
} from 'modules/theme';
import Select from 'react-select-plus';
import JSONInput from 'react-json-editor-ajrm';
import locale from 'react-json-editor-ajrm/locale/en';
import {
  ModalFooter,
  FormWrapper,
  FormColumn,
  ColumnTitle,
  InfoWrapper
} from 'modules/theme';
import { Textarea } from '../../../../theme';
import { ControlLabels } from '../../Integrations/styles';
import { ModalForm, ModalFormContainer } from '../../../../theme/theme1/common/styles/main';
import { ModalSmallIconButton } from '../styles';


class SmsProviderAddEdit extends Component {
  constructor(props) {
    super(props);

    this.saveData = this.saveData.bind(this);
    this.renderFormGroup = this.renderFormGroup.bind(this);

    this.mAPI = new APIManager();
    if (this.props.editData && this.props.editData._id) {
      this.state = {
        name: this.props.editData.name,
        updateBy: this.props.editData.updateBy,
        url: this.props.editData.url,
        reqType: this.props.editData.reqType,
        headersList: this.convert(this.props.editData.headers),
        bodyList: this.convertArray(this.props.editData.body)
      };
    } else {
      this.state = {
        name: '',
        url: '',
        list: {},
        reqType: null,
        headers: {},
        body: {},
        headersList: [{ key: '', value: '' }],
        bodyList: [{ key: '', value: '' }],

      };
    }
  }

  convert(headers) {
    let headersList = [];
    for (let key in headers) {
      console.log(key);
      console.log(headers[key])

      let result = { key: key, value: headers[key] }
      headersList.push(result);
    }
    return headersList;
  }

  convertArray(body) {
    let bodyList = [];
    for (let key in body) {
      console.log(key);
      console.log(body[key])

      let result = { key: key, value: body[key] }
      bodyList.push(result);
    }
    return bodyList;
  }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }
  generateTypeParams(data) {
    return data.map(type => ({
      value: type,
      label: type
    }));
  }

  resetAllData() {
    this.setState({
      name: '',
      //type: '',
    });
  }
  addClick() {
    this.setState(prevState => ({
      headersList: [...prevState.headersList, { key: '', value: '' }]
    }));
  }

  removeClick(i) {
    let headersList = [...this.state.headersList];
    if (headersList.length === 1) {
      Alert.error(`Atleast one header needed`);
    } else {
      headersList.splice(i, 1);
    }
    this.setState({ headersList });
  }

  addBodyClick() {
    this.setState(prevState => ({
      bodyList: [...prevState.bodyList, { key: '', value: '' }]
    }));
  }

  removeBodyClick(i) {
    let bodyList = [...this.state.bodyList];
    if (bodyList.length === 1) {
      Alert.error(`Atleast one body needed`);
    } else {
      bodyList.splice(i, 1);
    }
    this.setState({ bodyList });
  }

  renderName() {
    return (
      <FormWrapper>
        <FormColumn>
          {this.renderFormGroup('Name', {
            defaultValue: '',
            placeholder: 'Name',
            autoFocus: true,
            required: true,
            id: 'name',
            value: this.state.name,
            maxLength: 25,
            onChange: e => {
              this.setState({ name: !e.target.value.trim() && e.target.value !== "" ? "" : e.target.value });
            }
          })}
        </FormColumn>
      </FormWrapper >
    )
  }
  renderURL() {
    return (
      this.renderFormGroup('URL', {
        defaultValue: '',
        placeholder: 'URL',
        autoFocus: false,
        required: true,
        id: 'url',
        value: this.state.url,
        onChange: e => {
          this.setState({ url: e.target.value });
        }
      })
    )
  }
  renderReqType() {
    return (
      <FormGroup>
        <ControlLabel required={true}>Method</ControlLabel>
        <Select
          placeholder="Select Method Type"
          value={this.state.reqType}
          options={this.generateTypeParams([
            'GET',
            'POST',
          ])}
          onChange={items => {
            if (items && items.value) {
              this.setState({ reqType: items.value })
            } else {
              this.setState({ reqType: null })
            }
          }}
        />
      </FormGroup>
    )
  }
  renderHeaders() {
    return (
      <FormWrapper>
        <FormColumn>
          <FormGroup>
            <ControlLabels>Header</ControlLabels>
            <div style={{
              padding: '15px',
              borderRadius: '5px'
            }}>
              {this.headersList()}
            </div>


          </FormGroup>
        </FormColumn>
      </FormWrapper >
    )
  }
  headersRow(el, i) {
    return (
      <div key={i} style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
        <FormWrapper style={{ width: '100%' }}>
          <FormColumn>
            <ControlLabel>Key</ControlLabel>
            <FormControl
              name="key"
              type="key"
              placeholder="Add Key"
              value={el.key}
              onChange={e => {
                if (el) {
                  if(e.target.value !== " ")
                  {
                    el.key = e.target.value;
                  }
                }
                this.setState({ headersList: this.state.headersList });
              }}
              required={false}
              autoComplete="off"
            />
          </FormColumn>
          <FormColumn>
            <ControlLabel>Value</ControlLabel>
            <FormControl
              name="value"
              type="value"
              placeholder="Add Value"
              value={el.value}
              onChange={e => {
                if (el) {
                  el.value = e.target.value || "";
                }
                this.setState({ headersList: this.state.headersList });
              }}
              required={false}
              autoComplete="off"
            />
          </FormColumn>
        </FormWrapper>
        <ModalSmallIconButton className='ml-2'>
        <Tip text={`${'Add'}`} key={`${'Add'}`}>
          <Button
            btnStyle="link"
            onClick={this.addClick.bind(this, i)}
            style={{
              "verticalAlign": 'middle',
              "fontSize": "18px",
              "padding": "9px"
            }}
            icon="plus-circle"
          />
        </Tip>
        <Tip text={`${'Remove'}`} key={`${'Remove'}`}>
          <Button
            btnStyle="link"
            onClick={this.removeClick.bind(this, i)}
            style={{
              "verticalAlign": 'middle',
              "fontSize": "16px",
              "padding": "9px"
            }}
            icon="minus-circle"
          />
        </Tip>
        </ModalSmallIconButton>
      </div>
    )
  }
  headersList() {
    console.log(this.state)
    let list = this.state.headersList.map((el, i) => {
      return this.headersRow(el, i);
    });
    return list;
  }

  bodyRow( el, i) {
    return (
      <div key={i} style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
        <FormWrapper style={{ width: '100%' }}>
          <FormColumn>
            <ControlLabel>Key</ControlLabel>
            <FormControl
              name="key"
              type="key"
              placeholder="Add Key"
              value={el.key}
              onChange={e => {
                if (el) {
                  if(e.target.value !== " ")
                  {
                    el.key = e.target.value;
                  }
                }
                this.setState({ bodyList: this.state.bodyList });
              }}
              required={false}
              autoComplete="off"
            />
          </FormColumn>
          <FormColumn>
            <ControlLabel>Value</ControlLabel>
            <FormControl
              name="value"
              type="value"
              placeholder="Add Value"
              value={el.value}
              onChange={e => {
                if (el) {
                  el.value = e.target.value || "";
                }
                this.setState({ bodyList: this.state.bodyList });
              }}
              required={false}
              autoComplete="off"
            />
          </FormColumn>
        </FormWrapper>

        <ModalSmallIconButton className='ms-2'>
        <Tip text='Add' key={`${'Add'}`}>
          <Button
            btnStyle="link"
            onClick={this.addBodyClick.bind(this, i)}
            style={{
              "verticalAlign": 'middle',
              "fontSize": "18px",
              "padding": "9px"
            }}
            icon="plus-circle"
          />
        </Tip>
        <Tip text={`${'Remove'}`} key={`${'Remove'}`}>
          <Button
            btnStyle="link"
            onClick={this.removeBodyClick.bind(this, i)}
            style={{
              "verticalAlign": 'middle',
              "fontSize": "16px",
              "padding": "9px"
            }}
            icon="minus-circle"
          />
        </Tip>
        </ModalSmallIconButton>
      </div>
    )
  }

  bodyList() {
    let list = this.state.bodyList.map((el, i) => {
      return this.bodyRow(el, i);
    });
    return list;
  }

  renderBody() {
    return (
      <FormWrapper>
        <FormColumn>
          <FormGroup>
            <ControlLabels>Body</ControlLabels>
            <div style={{
              padding: '15px',
              borderRadius: '5px'
            }}>
              {this.bodyList()}
            </div>
          </FormGroup>
        </FormColumn>
      </FormWrapper >
    )
  }


  apiResponse(errorCode, data) {
    if (errorCode === 201) {
      let message = data && data.message ? data.message : 'Successfully Done';
      Alert.success(`${message}`);
      this.resetAllData();
      this.props.closeModal(true);
    } else {
      let message = data && data.message ? data.message : 'Something wrong happened';
      Alert.error(`${message}`);
    }
  }
  object(list) {
    let headers = {}
    this.state.headersList.map((el) => {
      headers[el.key] = el.value
    })
    return headers;
  }

  obj(list) {
    let body = {}

    this.state.bodyList.map((el) => {
      body[el.key] = el.value
      console.log(body)
    })
    return body;
  }

  saveData(e) {
    let _this = this;
    e.preventDefault();
    this.props.clearSearchField();
    let headerData = this.object(this.state.headersList)
    let bodyData = this.obj(this.state.bodyList)
    let name = this.state.name.trim();
	let validUrl = /^(https?:\/\/)?([a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)*\.[a-zA-Z]{2,6})(\/[a-zA-Z0-9_\-\.~:\/\?#\[\]@!\$&'\(\)\*\+,;=]*)?(\?[a-zA-Z0-9_\-\.~:\/\?#\[\]@!\$&'\(\)\*\+,;=]*)?$/;
	if (!validUrl.test(this.state.url)) {
		return Alert.error('Enter a valid URL')
	}
	if (!this.state.reqType) {
		return Alert.error('Select a method');
	}
    let tData = {
      name: name,
      type: "text",
      reqType: this.state.reqType,
      url: this.state.url,
      headers: headerData,
      body: bodyData
    };
    console.log('tdata',tData)


    if (this.props.editData && this.props.editData._id) {
      this.mAPI.sendPostAPI(
        `setting/sms-servicer/${this.props.editData._id}`,
        tData,
        data => {
          console.log(JSON.stringify(data, null, 2));
          if (data) {
            _this.resetAllData();
            _this.props.closeModal(true);
            Alert.success('SMS Provider updated successfully');
          }
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        },
        'private',
        { id: tData._id },
        'PUT'
      );
    } else {
      this.mAPI.sendPostAPI(
        'setting/sms-servicer',
        tData,
        data => {
          if (data && data.message) {
            Alert.success(`${'SMS Provider created successfully'}`);
          }
          this.resetAllData();
          this.props.update();
          this.props.closeModal(true);
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        }
      );
    }
  }

  render() {
    const { __ } = this.context;
    const { modalType } = this.props;
    return (
      <ModalForm onSubmit={e => this.saveData(e)}>
        <ModalFormContainer>
        <FormWrapper>
          <FormColumn>
            {this.renderName()}
          </FormColumn>
        </FormWrapper>
        <FormWrapper>
          <FormColumn>
            <FormGroup>
              {this.renderURL()}
            </FormGroup>
          </FormColumn>
        </FormWrapper>
        <FormWrapper>
          <FormColumn>
            <FormGroup>
              {this.renderReqType()}
            </FormGroup>
          </FormColumn>
        </FormWrapper>
        <FormWrapper>
          <FormColumn>
            <FormGroup>
              {this.renderHeaders()}
            </FormGroup>
          </FormColumn>
        </FormWrapper>
        <FormWrapper>
          <FormColumn>
            <FormGroup>
              {this.state.reqType !== 'GET' && this.renderBody()}
            </FormGroup>
          </FormColumn>
        </FormWrapper>
        </ModalFormContainer>
        <ModalFooter modalType={modalType}>
          <ButtonCommonTheme
            type='greyModalBtn'
            btnStyle="cancel"
            OnClick={() => this.props.closeModal()}
            size="xl"
          >
            Cancel
          </ButtonCommonTheme>
          <ButtonCommonTheme
            type="blueModalBtn"
            btnType="submit"
            btnStyle="default"
            size="xl"
            style={{ float: 'right' }}
          >
            {this.props.editData && this.props.editData._id ? 'Update' : 'Add'}
          </ButtonCommonTheme>
        </ModalFooter>
      </ModalForm>
    );
  }
}

SmsProviderAddEdit.propTypes = {
  group: PropTypes.array
};

SmsProviderAddEdit.contextTypes = {
  __: PropTypes.func
};

export default SmsProviderAddEdit;



// WEBPACK FOOTER //
// src/modules/screens/settings/SmsProvider/components/SmsProviderAddEdit.js